import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  Button,
  MODAL_SIZE_LG,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { modalRecipientGroupsCloseCallback } from 'Pages/RecipientsList/recoil/callbacks/modalRecipientGroups'
import { modalRecipientGroupsState } from 'Pages/RecipientsList/recoil/state/modalRecipientGroups'

import GroupsList from 'Pages/RecipientsList/components/modals/recipientGroups/GroupsList'

const ModalRecipientGroups: FC = () => {
  const intl = useIntl()

  const { show, contact } = useRecoilValue(modalRecipientGroupsState)

  const handleCancel = useRecoilCallback(modalRecipientGroupsCloseCallback, [])

  return (
    <Modal
      size={MODAL_SIZE_LG}
      show={show}
      onClose={handleCancel}
      closeOnOverlayClick
      data-mu-test="modal-recipient-groups"
    >
      <ModalHead
        title={intl.formatMessage(
          {
            id: 'Load.RecipientsList.ModalRecipientGroupsTitle',
          },
          { CONTACT: contact },
        )}
      />
      <ModalBody scrollable scrollableHeight="450px">
        <GroupsList />
      </ModalBody>
      <ModalFoot>
        <Button data-mu-test="action-close" onClick={handleCancel}>
          {intl.formatMessage({ id: 'Load.Common.Close' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalRecipientGroups
